module.exports = __webpack_public_path__ + "img/icon-positive-survey.15f84caa.svg";